import { message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { serverFetch } from '@server';
import { userLoaded } from '@redux/actions';
import { useDicts } from './dicts';
import { showError } from './utils';

// Хук смены активной фирмы (суперадмин): SelectCompany + перезагрузка справочников + обновление user.
// url — адрес, который откроется уже в новой фирме
export function useSelectCompany() {
    const dispatch = useDispatch();
    const user = useSelector((s) => s.user);
    const { reloadDicts } = useDicts();

    const selectCompany = ({ id, name }, url) => {
        return serverFetch(`auth/SelectCompany/${id}`, { method: 'PUT' })
            .then(() => reloadDicts())
            .then(() => {
                // Смена фирмы пересоздаёт роутер (App), он стартует с window.location — поэтому адрес до dispatch
                if (url) window.history.pushState(null, '', url);
                dispatch(userLoaded({ ...user, companyId: id, companyName: name }));
                message.info(`Выбрана фирма «${name}»`);
                return true;
            })
            .catch((e) => {
                showError(e);
                return false;
            });
    };

    return selectCompany;
}
